import React from 'react';

const StatsBar = () => {
  const stats = [
    { icon: 'corporate_fare', label: '200+ Companies', sublabel: 'Trust Pulpit Cabs' },
    { icon: 'map', label: '15+ Cities', sublabel: 'Across India' },
    { icon: 'route', label: '50,000+ Rides', sublabel: 'Every Month' },
    { icon: 'star', label: '4.8 / 5 Rating', sublabel: 'Customer Satisfaction' },
  ];

  return (
    <div className="bg-surface-container-low border-y border-outline-variant/30">
      <div className="max-w-[1400px] mx-auto px-[32px] py-[32px] flex flex-wrap justify-between items-center gap-[32px]">
        {stats.map((stat, index) => (
          <div key={index} className="flex items-center gap-[16px]">
            <div className="w-[48px] h-[48px] rounded-full bg-primary/10 flex items-center justify-center text-primary">
              <span className="material-symbols-outlined">{stat.icon}</span>
            </div>
            <div>
              <div className="font-bold text-on-surface">{stat.label}</div>
              <div className="text-[12px] text-on-surface-variant uppercase tracking-wider">{stat.sublabel}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsBar;


